// extracted by mini-css-extract-plugin
export default {"seasons":"seasons__Ox199"};